import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './pages/home';
import Villas from './pages/Villa-Details';
import Error from './pages/error';
import Projects from './pages/projects';
import Login from './pages/login';
import VRViewer from './components/layout/VRViewer';

const Routess = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/villas" element={<Villas />} />
        <Route path="/login" element={<Login />} />
        <Route path="/vr-tour" element={<VRViewer />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Routess;